/**
 * Normaliza a resposta de um endpoint de lista para SEMPRE devolver um array.
 *
 * Aceita os dois formatos que a API usa na prática:
 *   - envelope `{ data: [...] }` (maioria dos endpoints via API Resource)
 *   - array cru no corpo `[...]` (ex.: `/subscriptions/plans`)
 *
 * Qualquer outro 200 inesperado (corpo sem `data`, HTML de proxy, etc.) cai
 * para `[]` em vez de `undefined` — evitando que um `.map` no consumidor
 * estoure e derrube a tela inteira via ErrorBoundary (ver crash de Moodboard).
 *
 * NÃO use para fluxos onde uma lista vazia muda o comportamento (ex.: "não
 * achei → cria") — nesses casos uma resposta torta deve falhar alto, não
 * virar `[]` silencioso.
 */
export function unwrapList<T = unknown>(payload: unknown): T[] {
    const raw = Array.isArray(payload)
        ? payload
        : (payload as { data?: unknown } | null | undefined)?.data;
    return Array.isArray(raw) ? (raw as T[]) : [];
}
